module.exports = __webpack_public_path__ + "static/media/desaliTec_Membrane.37c7b746.svg";